module.exports = __webpack_public_path__ + "static/media/Sec-1_Home2_EN.9d8a2efa.webp";